import type { CardChangeEvent, ChangeEvent } from '@basis-theory/react-elements'

import { FormItemDto, isFormItemInputDto } from '@model/WalletPaymentProviderParametersDto'

export type BtFieldState = {
  empty: boolean
  complete: boolean
  valid: boolean
  hasErrors: boolean
  selectedNetwork?: string
  cardBrand?: string
}

export const EMPTY_BT_FIELD_STATE: BtFieldState = {
  empty: true,
  complete: false,
  valid: false,
  hasErrors: false,
  selectedNetwork: undefined,
  cardBrand: undefined,
}

type AnyBtChangeEvent = CardChangeEvent | ChangeEvent

const pickString = (v: unknown): string | undefined => (typeof v === 'string' ? v : undefined)

export const toBtFieldState = (e?: AnyBtChangeEvent | null): BtFieldState => {
  const anyE = e as unknown as Record<string, unknown> | null | undefined

  return {
    empty: typeof e?.empty === 'boolean' ? e.empty : true,
    complete: !!e?.complete,
    valid: !!e?.valid,
    hasErrors: Array.isArray(e?.errors) && e.errors.length > 0,
    cardBrand: pickString(anyE?.cardBrand),
    selectedNetwork: pickString(anyE?.selectedNetwork),
  }
}

export const hasTokenizedCardParams = (form: Array<{ field?: string }> = []): boolean => {
  const hasTokenizedCardId = form.some((item) => item.field === 'tokenized_card_id')
  const hasTokenizedIntentFlag = form.some((item) => item.field === 'is_tokenized_card_id_intent')
  return hasTokenizedCardId && hasTokenizedIntentFlag
}

export const isThreeDSRequired = (form: FormItemDto[] = []): boolean => {
  const item = form.find((f) => f.field === 'requires_3ds')
  return isFormItemInputDto(item) && item.value.toLowerCase() === 'true'
}

const maskedCardNumberPattern = /^(\d{4}).*(\d{4})$/
export const formatMaskedCardNumber = (value?: string): string => {
  if (!value) return ''
  const match = value.match(maskedCardNumberPattern)
  if (!match) return value
  const [, first4, last4] = match
  return `${first4} **** **** ${last4}`
}

export const formatExpiryDate = (value?: string): string => {
  if (!value) return ''
  const [month, year] = value.split('/')
  if (!month || !year) return value
  const shortYear = year.length >= 2 ? year.slice(-2) : year
  return `${month}/${shortYear}`
}
